"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  angular.module("pcmCommon").factory("ArrivalTime", [function () {

    var DATETIME_FORMAT = "HH:mm"; //Used internally by the UI datetime widgets

    //class that represents an arrival time

    var ArrivalTime = function () {
      function ArrivalTime(params) {
        _classCallCheck(this, ArrivalTime);

        //Whether or not to use earliest/latest arrival time
        this.enabled = false;

        //0 = earliest arrival time, 1 = latest
        this.type = params.type;

        //The datetime string representation for the arrival time. Format in: 10:15 AM
        this.arrivalTime = "";

        this.checkboxLabel = params.checkboxLabel;

        this.weekDayTimeLabel = params.weekdayTimeLabel;

        if (params.arrivalTime) {
          this.arrivalTime = params.arrivalTime;
          this.enabled = true;
        } else {
          this.arrivalTime = moment().format(DATETIME_FORMAT);
        }
      }

      _createClass(ArrivalTime, [{
        key: "hasValue",
        value: function hasValue() {
          return this.enabled;
        }
      }, {
        key: "getWsMomentTime",
        value: function getWsMomentTime() {
          if (this.hasValue()) {
            return moment(this.arrivalTime, DATETIME_FORMAT);
          } else {
            if (this.type === 0) {
              return moment().startOf("day");
            } else {
              return moment().endOf("day");
            }
          }
        }
      }, {
        key: "getWsFormattedTime",
        value: function getWsFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }
      }, {
        key: "getUIFormattedTime",
        value: function getUIFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }
      }]);

      return ArrivalTime;
    }();

    return ArrivalTime;
  }]);
})();


// WEBPACK FOOTER //
// ./app/pcm-common/ArrivalTime.module.js